import React from 'react';
import CarnetMuscuSettingsManager from './CarnetMuscuSettingsManager';

/**
 * Wrapper: CarnetSettingsDialog
 * - forwards props to CarnetMuscuSettingsManager (Dialog)
 *
 * Props: open, onClose
 */
export default function CarnetSettingsDialog(props) {
  return <CarnetMuscuSettingsManager {...props} />;
}